/**
 * Il widget sa su che sfondo si trova: i pezzi comuni (numeri, pillole,
 * barre, stati vuoti) si colorano di conseguenza, bianchi sui widget colorati
 * e scuri su quelli chiari. Lo imposta la cornice del widget.
 */

import { createContext, useContext } from 'react';

export const ContestoTema = createContext<{ scuro: boolean }>({ scuro: false });

export function useTemaScuro(): boolean {
  return useContext(ContestoTema).scuro;
}
